











import {
  computed, defineComponent, ref, watch,
} from '@vue/composition-api';

import { shortNumberFormatter } from '@/utils';

const ChartWithMoneyAxis = defineComponent({
  props: {
    data: {},
    xAxisLabel: { default: 'เดือน' },
    yAxisLabel: { default: 'รายได้ (บาท)' },
    height: {
      type: String,
      default: '',
    },
    formatYAxis: {
      type: Boolean,
      default: true,
    },
    scales: { default: () => ({}) },
    plugins: { default: () => ({}) },
    perPage: { type: Number, default: 5 },
    maxY: { default: undefined },
    minY: { default: undefined },
    yTicks: { type: Object, default: undefined },
  },
  setup(props) {
    const chart = ref(null);
    const startItem = ref(0);
    const options = {
      scales: {
        x: {
          min: 0,
          max: props.perPage,
          display: true,
          title: {
            display: true,
            text: props.xAxisLabel,
          },
        },
        y: {
          max: props.maxY,
          title: {
            display: true,
            text: props.yAxisLabel,
          },
          ticks: {
            // eslint-disable-next-line
            callback: (value: number) => props.formatYAxis ? `${shortNumberFormatter(value, 2)}` : value,
            // ...props.yTicks,
          },
        },
        ...props.scales,
      },
      plugins: {
        ...props.plugins,
      },
    };

    const dataLength = computed(() => ((props.data as any)?.labels?.length || 0) as number);
    const displayLength = computed(() => (props.perPage + 1) || 0);
    const hiddenLength = computed(() => dataLength.value - displayLength.value);

    function scroll($event: any) {
      if (dataLength.value > 0 && displayLength.value > 0) {
        if (
          ($event.deltaY > 0 || $event.deltaX > 0)
          && startItem.value < hiddenLength.value
        ) {
          startItem.value += 1;
          (chart.value as any).updateX(1);
        } else if (
          ($event.deltaY < 0 || $event.deltaX < 0)
          && startItem.value > 0
        ) {
          startItem.value -= 1;
          (chart.value as any).updateX(-1);
        }
        (chart.value as any).rerenderChart();
      }
    }

    watch(() => props.maxY, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        if (chart.value) {
          (chart.value as any).setMaxY(newVal);
          (chart.value as any).rerenderChart();
        }
      }
    });
    watch(() => props.minY, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        if (chart.value) {
          (chart.value as any).setMinY(newVal);
          (chart.value as any).rerenderChart();
        }
      }
    });

    return {
      chart,
      options,
      scroll,
    };
  },
});

export default ChartWithMoneyAxis;
